import { render, staticRenderFns } from "./SingolaRilevazioneDettagliata.vue?vue&type=template&id=1dac7774"
import script from "./SingolaRilevazioneDettagliata.vue?vue&type=script&lang=js"
export * from "./SingolaRilevazioneDettagliata.vue?vue&type=script&lang=js"
import style0 from "./SingolaRilevazioneDettagliata.vue?vue&type=style&index=0&id=1dac7774&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports